import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const location = useLocation();

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isActive = (path) => location.pathname === path;

  // Toggle mobile navigation
  const handleMobileNavToggle = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  return (
    <div className="index-page">
      <header
        id="header"
        className={`header d-flex align-items-center fixed-top ${
          scrolled ? "scrolled" : "transparent"
        }`}
      >
        <div className="container-fluid position-relative d-flex align-items-center justify-content-between">
          <Link
            to="/"
            className="logo d-flex align-items-center me-auto me-xl-0"
          >
            <img src="../../assets/img/logo1.png" alt="img"></img>
          </Link>

          <nav
            id="navmenu"
            className={`navmenu ${isMobileNavOpen ? "navmenu-open" : ""}`}
          >
            <ul className="mobilemenu">
              <li>
                <Link to="/" className={isActive("/") ? "active" : ""}>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/About"
                  className={isActive("/About") ? "active" : ""}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/Service"
                  className={isActive("/Service") ? "active" : ""}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/Authform"
                  className={isActive("/Service") ? "active" : ""}
                >
                  Login/singup
                </Link>
              </li>
              <li></li>
              <li>
                <Link
                  to="/Ourproject"
                  className={isActive("/Ourproject") ? "active" : ""}
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link
                  to="/Contact"
                  className={isActive("/Contact") ? "active" : ""}
                >
                  Contact
                </Link>
              </li>
            </ul>
            {/* Mobile Nav Toggle */}
            <i
              className={`mobile-nav-toggle d-xl-none bi bi-list ${
                scrolled ? "black-text" : "white-text"
              }`}
              onClick={handleMobileNavToggle}
            ></i>
          </nav>
          <Link className="btn-getstarted" to="/Service">
            Book Our Services
          </Link>
        </div>
      </header>
    </div>
  );
};

export default Header;
